import anime from 'animejs';
import { scrollIt } from "../utils/_scroll-it";

export default function Modal () {
    const body = document.body;
    let closing = false;

    document.addEventListener("DOMContentLoaded", function() {

        const addEventBtns = document.querySelectorAll('.open-modal');

        for (let i = 0; i < addEventBtns.length; i++) {

            const btn = addEventBtns[i];

            // close modal on button close
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const ID = btn.getAttribute('data-id');
                openModal(document.querySelector('.modal[data-id="'+ ID +'"]'));
            });
        }

        /**
         * Close modals
         */
        const modalOuters = document.querySelectorAll('.modal-outer');
        const closeBtns = document.querySelectorAll('.close-modal');

        for (let i = 0; i < closeBtns.length; i++) {

            const close = closeBtns[i];
            const modal = getClosest(closeBtns[i], '.modal-outer');

            // close modal on button close
            close.addEventListener('click', () => {
                closeModal();
            });

            // close modal on when clicking outside modal
            modal.addEventListener('click', (e) => {

                if (e.target.classList.contains('modal-outer')) {
                    closeModal();
                }
            });
        }

        for (let i = 0; i < modalOuters.length; i++) {

            const modalOuter = modalOuters[i];
            modalOuter.addEventListener('click', (e) => {
                if (e.target.classList.contains('modal-outer')) {
                    closeModal();
                }
            });
        }

        // close modal on escape
        document.onkeydown = function (evt) {

            evt = evt || window.event;

            if (evt.keyCode === 27 && body.classList.contains('modal-open')) {

                closeModal();
            }
        };

    });

    /**
     * Functions
     */

    function openModal(modal) {
        anime({
            targets: modal.children[0],
            opacity: [0, 1],
            translateY: [-30, 0],
            duration: 300,
            easing: 'easeOutCubic',
            delay: 200
        });

        body.classList.add('modal-open');
        modal.classList.add('active');
    }

    function closeModal() {

        if (closing) return false;

        closing = true;

        setTimeout(() => {
            closing = false;
        }, 1000);

        let modal = document.querySelector('.modal-outer.active');

        body.classList.remove('modal-open');

        anime({
            targets: '.modal-inner',
            opacity: [1, 0],
            translateY: [0, -30],
            duration: 300,
            easing: 'easeOutCubic'
        });

        setTimeout( function() {
            modal.classList.remove('active');
        }, 300);

        let modalevent = document.createEvent('Event');
        modalevent.initEvent('modalclosed', true, true);
        modal.dispatchEvent(modalevent);
    }

    // find closest element by class
    function getClosest(elem, selector) {

        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    let matches = (this.document || this.ownerDocument).querySelectorAll(s),
                        i = matches.length;
                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }

        // Get the closest matching element
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;

    }

    window.closeModal = closeModal; // Make method available in global scope
    window.openModal = openModal; // Make method available in global scope
    window.getClosest = getClosest; // Make method available in global scope
}